import React from "react";
import { ContactSection } from "./Landing";
import HomeLayout from "../layouts/home";

function Contact() {
  
  return (
    <HomeLayout>
      <ContactSection noImage />
    </HomeLayout>
  );
}

export default Contact;
